import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  constructor(private translate: TranslateService, private router: Router) {
    this.translate.addLangs(['es', 'en']);

    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage === 'es' || savedLanguage === 'en') {
      this.translate.use(savedLanguage);
    } else {
      this.translate.setDefaultLang('es');
      localStorage.setItem('language', 'es');
    }

  }
  //Herko
  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Enviar vista de página a Google Analytics
        if (!event.urlAfterRedirects.includes("/callback/")) {
          gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects
          });
        }
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts